export const NightAudioData = {
    noise: {
        volume: -36,
        filterFreqency: "8m",
        type: "white",
    },
    voiceover: {
        id: "night-voiceover",
    },
    scenes: [
        {
            name: "Intro",
            tracks: [
                {
                    samplePool: ["scene0-strings"],
                    length: 36,
                    velocity: 0.3,
                    startRange: 1,
                },
                {
                    samplePool: ["scene0-piano"],
                    length: 32,
                    velocity: 0.5,
                    startRange: 4,
                },
                {
                    samplePool: ["scene0-guitar"],
                    length: 34,
                    velocity: 0.5,
                    startRange: 8,
                },
                {
                    samplePool: ["scene0-organ"],
                    length: 33,
                    velocity: 0.2,
                    startRange: 3,
                },
            ],
            loopsVolume: -9,
            fadeOutDuration: 8,
            resetTransport: true,
        },
        {
            name: "Kingdom",
            tracks: [
                {
                    samplePool: ["scene1-strings"],
                    velocity: 0.3,
                    length: 22,
                    startRange: 3,
                },
                {
                    samplePool: ["scene1-piano"],
                    velocity: 0.5,
                    length: 17,
                    startRange: 1,
                },
                {
                    samplePool: ["scene1-guitar"],
                    velocity: 0.5,
                    length: 20,
                    startRange: 8,
                },
                {
                    samplePool: ["scene1-organ"],
                    velocity: 0.1,
                    length: 29,
                    startRange: 1,
                },
            ],
            loopsVolume: -9,
            fadeOutDuration: 8,
            resetTransport: true,
        },
        {
            name: "KingQueen",
            tracks: [
                {
                    samplePool: ["scene2-piano"],
                    velocity: 0.5,
                    length: 14,
                    startRange: 8,
                },
                {
                    samplePool: ["scene2-guitar-loop"],
                    length: 8.534,
                },
                {
                    samplePool: ["scene2-organ"],
                    velocity: 0.3,
                    length: 15,
                },
                {
                    samplePool: ["scene2-bass"],
                    velocity: 0.3,
                    length: 18,
                },
            ],
            loopsVolume: -9,
            fadeOutDuration: 8,
            resetTransport: true,
        },
        {
            name: "Castle",
            tracks: [
                {
                    samplePool: ["scene3-guitar"],
                    velocity: 0.8,
                    length: 15,
                },
                {
                    samplePool: ["scene3-strings"],
                    velocity: 0.8,
                    length: 17,
                    startRange: 6,
                },
            ],
            loopsVolume: -9,
            fadeOutDuration: 8,
            resetTransport: true,
        },
        {
            name: "MonsterBehind",
            // tracks: [
            //     {
            //         samplePool: ["scene4-guitar"],
            //         velocity: 0.8,
            //         length: 31,
            //     },
            //     {
            //         samplePool: ["scene4-jules"],
            //         velocity: 0.8,
            //         length: 31,
            //     },
            // ],
            background: {
                samplePool: ["scene5-mix"],
                loopStart: 0,
                loopEnd: 32,
            },
            loopsVolume: -9,
            fadeOutDuration: 8,
            resetTransport: true,
        },
        {
            name: "Rabbits",
            tracks: [
                {
                    samplePool: ["scene5-guitar"],
                    velocity: 0.6,
                    length: 22,
                    startRange: 8,
                    resetTransport: true,
                },
                {
                    samplePool: ["scene5-jules"],
                    velocity: 0.1,
                    startRange: 2,
                    length: 14,
                    resetTransport: true,
                },
            ],
            loopsVolume: -6,
        },
        {
            // scene6
            name: "Monster2",
            tracks: [
                {
                    samplePool: ["scene7-guitar"],
                    velocity: 0.8,
                    length: 38,
                    // length: 40.541, this is scene 6 length
                },
                {
                    samplePool: ["scene7-jules"],
                    velocity: 0.8,
                    length: 38,
                },
                {
                    samplePool: ["scene7-bass"],
                    velocity: 0.8,
                    length: 38,
                },
            ],
            loopsVolume: -3,
            resetTransport: true,
        },
        {
            // scene7
            name: "MonsterFace",
            tracks: [
                {
                    samplePool: ["scene8-guitar"],
                    velocity: 0.8,
                    length: 52.707,
                    startRange: 8,
                },
                {
                    samplePool: ["scene8-jules"],
                    velocity: 0.8,
                    startRange: 14,
                    length: 52.707,
                },
                {
                    samplePool: ["scene8-low-ep"],
                    velocity: 0.8,
                    length: 52.707,
                },
            ],
            loopsVolume: -3,
            resetTransport: true,
        },
    ]
};
